import { render, staticRenderFns } from "./Macro.vue?vue&type=template&id=4cd644bd&scoped=true&"
import script from "./Macro.vue?vue&type=script&lang=js&"
export * from "./Macro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd644bd",
  null
  
)

export default component.exports